/**
 * @author Zdenka Valkučáková <zdenka.valkucakova@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/**
 * @import { IVariablesNamespace, VariablesValue } from '.'
 */

/** @implements {IVariablesNamespace} */
export default class InfoVariablesNamespace {
  /**
   * @param {Record<string, VariablesValue>} info Flatizovaný objekt info z ContentInfo.info
   */
  constructor(info) {
    this.info = info;
  }

  /** @type {IVariablesNamespace['getValue']} */
  getValue(key) {
    return this.info?.[key];
  }
}
